import {
  SYNC_CONCURRENCY_HELP,
  getPreviewRecipientKey,
  isRegisteredPreviewSend,
  type DecisionEngineDestinationDefinition,
} from "./definition";
import { hightouchPayloadMapping } from "./sync-config-helpers";

export const cordialDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "cordial",
  category: "trigger",
  generateSyncConfig: ({
    producer,
    settings,
    isPreview,
    sendToHightouchUser,
    previewRecipientMode,
    messageTags,
  }) => {
    const registeredPreview = isRegisteredPreviewSend({
      isPreview,
      previewRecipientMode,
    });
    const previewRecipientKey = getPreviewRecipientKey(settings);
    return {
      type: "trigger",
      templateKey: { type: "standard", from: "campaign_id" },
      mappings: [hightouchPayloadMapping({ producer, messageTags })],
      // Registered mode without a key falls back to email keying even on cID
      // channels: the registered recipient is the account address, so
      // external_id would otherwise be sent as a nonexistent cID.
      externalIdMapping:
        registeredPreview && previewRecipientKey
          ? {
              type: "static",
              to: "cID",
              value: previewRecipientKey,
              valueType: "STRING",
            }
          : registeredPreview
            ? { from: "external_id", to: "email" }
            : {
                from: "external_id",
                to:
                  settings.recipientType === "cID" &&
                  !(isPreview && sendToHightouchUser)
                    ? "cID"
                    : "email",
              },
    };
  },
  // The Cordial trigger sync reads both keys at runtime (defaults 500 / 5);
  // the rETL config sets no cap, so these bounds just keep overrides sane.
  syncTuning: {
    batchSize: {
      defaultValue: 500,
      configKey: "rowsPerBatch",
      max: 1000,
      label: "Send batch size",
      description:
        "Rows processed together, then split into requests by template and recipient limits.",
    },
    parallelization: {
      defaultValue: 5,
      max: 100,
      label: "Concurrent send batches",
      description:
        "Controls how many send batches run in parallel. Each batch can make multiple concurrent requests.",
      help: SYNC_CONCURRENCY_HELP,
    },
  },
};
